import PocketBase from "pocketbase";

// Initialize PocketBase client
const pb = new PocketBase(
  process.env.REACT_APP_POCKETBASE_URL || "http://127.0.0.1:8090"
);

// Collection names
export const COLLECTIONS = {
  ITEMS: "items",
  COLUMNS: "columns",
};

// Types for PocketBase records
export interface PBItem {
  id: string;
  content: string;
  column: string;
  order: number;
  created: string;
  updated: string;
}

export interface PBColumn {
  id: string;
  title: string;
  order: number;
  created: string;
  updated: string;
}

// Authentication functions
export const auth = {
  async login(email: string, password: string) {
    return await pb.admins.authWithPassword(email, password);
  },

  async logout() {
    pb.authStore.clear();
  },

  isAuthenticated() {
    return pb.authStore.isValid;
  },
};

// API functions
export const api = {
  // Items
  async getItems() {
    return await pb.collection(COLLECTIONS.ITEMS).getFullList<PBItem>({
      sort: "order",
    });
  },

  async createItem(content: string, column: string) {
    const items = await this.getItems();
    const maxOrder = Math.max(...items.map((item) => item.order), -1);

    return await pb.collection(COLLECTIONS.ITEMS).create<PBItem>({
      content,
      column,
      order: maxOrder + 1,
    });
  },

  async updateItem(id: string, data: Partial<PBItem>) {
    return await pb.collection(COLLECTIONS.ITEMS).update<PBItem>(id, data);
  },

  async deleteItem(id: string) {
    return await pb.collection(COLLECTIONS.ITEMS).delete(id);
  },

  // Columns
  async getColumns() {
    return await pb.collection(COLLECTIONS.COLUMNS).getFullList<PBColumn>({
      sort: "order",
    });
  },

  async createColumn(title: string) {
    const columns = await this.getColumns();
    const maxOrder = Math.max(...columns.map((col) => col.order), -1);

    return await pb.collection(COLLECTIONS.COLUMNS).create<PBColumn>({
      title,
      order: maxOrder + 1,
    });
  },

  async updateColumn(id: string, data: Partial<PBColumn>) {
    return await pb.collection(COLLECTIONS.COLUMNS).update<PBColumn>(id, data);
  },

  async deleteColumn(id: string) {
    return await pb.collection(COLLECTIONS.COLUMNS).delete(id);
  },
};
